var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeorgia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3323",
    d: "M30 10H17V0h-4v10H0v4h13v10h4V14h13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3323",
    d: "M9 4.14q-.93.19-1.87.23.04-.93.23-1.87a7 7 0 0 1-1.72 0q.19.93.23 1.87A13 13 0 0 1 4 4.14q.12.86 0 1.72a13 13 0 0 1 1.87-.23 13 13 0 0 1-.23 1.87 7 7 0 0 1 1.72 0 13 13 0 0 1-.23-1.87q.93.04 1.87.23a7 7 0 0 1 0-1.72m12 0q.93.19 1.87.23a13 13 0 0 0-.23-1.87q.86.12 1.72 0a13 13 0 0 0-.23 1.87A13 13 0 0 0 26 4.14a7 7 0 0 0 0 1.72 13 13 0 0 0-1.87-.23q.04.93.23 1.87a7 7 0 0 0-1.72 0q.19-.93.23-1.87-.93.04-1.87.23a7 7 0 0 0 0-1.72M9 19.86a13 13 0 0 0-1.87-.23q.04.93.23 1.87a7 7 0 0 0-1.72 0q.19-.93.23-1.87-.93.04-1.87.23a7 7 0 0 0 0-1.72q.93.19 1.87.23a13 13 0 0 0-.23-1.87q.86.1 1.72 0a13 13 0 0 0-.23 1.87A13 13 0 0 0 9 18.14a7 7 0 0 0 0 1.72m12 0a13 13 0 0 1 1.87-.23 13 13 0 0 1-.23 1.87 7 7 0 0 1 1.72 0 13 13 0 0 1-.23-1.87q.93.04 1.87.23a7 7 0 0 1 0-1.72q-.93.19-1.87.23.04-.93.23-1.87a7 7 0 0 1-1.72 0q.19.93.23 1.87a13 13 0 0 1-1.87-.23q.1.86 0 1.72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeorgia);
export default __webpack_public_path__ + "static/media/georgia.2c0c26e14008ef556c0df34fe610d15c.svg";
export { ForwardRef as ReactComponent };